import { render } from "./OverlayTask.vue?vue&type=template&id=059ce191&scoped=true"
import script from "./OverlayTask.vue?vue&type=script&lang=js"
export * from "./OverlayTask.vue?vue&type=script&lang=js"

import "./OverlayTask.vue?vue&type=style&index=0&id=059ce191&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059ce191"]])

export default __exports__